export default {
  data() {
    return {
      // adviceSlip: {
      //   advice: {
      //     id: null,
      //     text: null,
      //   },
      //   photo: {
      //     id: null,
      //     url: null,
      //     author: {
      //       id: null,
      //       name: null,
      //     },
      //   },
      // },
      adviceSlip: null,
      loading: true,
      error: null,
    };
  },
  computed: {
    computedAdviceSlip() {
      return this.adviceSlip;
    },
    computedLoading() {
      return this.loading;
    },
    computedError() {
      return this.error;
    },
  },
  async created() {
    this.loading = true;

    const adviceId = this?.$route?.params?.id;

    const advice = await this.getAdvice(adviceId);

    const image = await this.getImage(advice?.advice);

    if (image && advice) {
      this.loading = false;
      this.error = null;
      this.adviceSlip = {
        advice: {
          id: advice?.id,
          text: advice?.advice,
        },
        photo: {
          id: image?.photo_id,
          url: image?.photo,
          alt: image?.altText,
          author: {
            id: image?.photographer_id,
            name: image?.photographer,
          },
        },
      };
      return;
    }

    this.loading = false;
    this.error = "Failed to fetch a random quote";
  },
  methods: {
    getRandomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    async getAdvice(id) {
      return await fetch(
        `https://api.adviceslip.com/advice${id ? "/" + id : ""}`
      )
        .then((response) => response.json())
        .then((data) => ({ id: data?.slip?.id, advice: data?.slip?.advice }))
        .catch(() => null);
    },
    async getImage(relatedTo) {
      // get data from serverless function
      return await fetch(
        // TODO: add a custom url
        `/.netlify/functions/photos?per_page=1&page=${this.getRandomNumber(
          1,
          15
        )}&query=${relatedTo}`
      )
        .then((response) => response.json())
        .then((data) => ({
          photographer_id: data?.photos?.[0]?.photographer_id,
          photographer: data?.photos?.[0]?.photographer,
          altText: data?.photos?.[0]?.alt || "Quote Image",
          photo: data?.photos?.[0]?.src?.large2x,
          photo_id: data?.photos?.[0]?.id,
        }))
        .catch(() => null);
    },
  },
};
